import { IoIosPeople } from "react-icons/io";
import { AiOutlineUserSwitch, AiOutlineFileDone } from "react-icons/ai";
import { MdOutlineDashboard } from "react-icons/md";
import { HiOutlineUsers } from "react-icons/hi";
import { BsFiles } from "react-icons/bs";
import { SlOrganization } from "react-icons/sl";
import { VscFeedback } from "react-icons/vsc";
import { RiSurveyFill } from "react-icons/ri";
import { IoChatbubbles } from "react-icons/io5";
import { FaQ } from "react-icons/fa6";
import { TbPlanet } from "react-icons/tb";
import { HiMiniPaperAirplane } from "react-icons/hi2";


export const sideNavbar = [
  {
    title: "Dashboard",
    path: "dashboard",
    icon: <MdOutlineDashboard />,
  },
  {
    title: "WorkForce",
    path: "admin/workforce",
    icon: <IoIosPeople />,
  },
  {
    title: "Organization",
    path: "admin/organization",
    icon: <SlOrganization />,
  },
  {
    title: "Survey's",
    path: "admin/survey",
    icon: <BsFiles />,
  },
  {
    title: "Master",
    path: "admin/master",
    icon: <AiOutlineUserSwitch />,
  },

  // {
  //   title: "Survey Assign",
  //   path: "admin/assigned-surveys",
  //   icon: <HiOutlineUsers />,
  // },
  {
    title: "Survey List",
    path: "user/survey-list",
    icon: <RiSurveyFill />,
  },
  {
    title: "Submited Survey",
    path: "user/submited-survey-list",
    icon: <AiOutlineFileDone />,
  },
  {
    title: "Feedback",
    path: "admin/feedback",
    icon: <VscFeedback />,
  },
  {
    title:"Communication",
    path:"user/communication",
    icon:<IoChatbubbles/>
  },
  {
    title:"FAQ",
    path:"user/faq",
    icon:<FaQ/>
  },
  {
    title:"Talent Matrix",
    path:"",
    icon:<TbPlanet/>
  },
  {
    title:"Development",
    path:"",
    icon:<HiMiniPaperAirplane/>
  },
  
];

export const landing_navbar = [
  { to: "home", title: "Home" },
  { to: "features", title: "Features" },
  { to: "pricing", title: "Pricing" },
  {
    to: "consulting-projects",
    title: "Consulting Projects",
    url: "/consulting-projects",
  },
  {
    to: "masterclass-certification",
    title: "Masterclass Certification",
    url: "/master-class-certification",
  },
  { to: "contact-us", title: "Contact Us" },
];
